angular.module('dealerware.web.data').factory('DealerwareVehicleContractCollection', function ($http,Collection,DealerwareVehicleContractModel,$q,DataUtils,$mobilityCompanyAuthentication) {

    'use strict';
    var collection = new Collection({
        baseEndpoint: '/locations/:location_id/cars/:car_id/car_reservations',
        model: 'DealerwareVehicleContractModel',
        customActions: {
            index: {
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreDefaultAssociationMapper: true
            },
            forVehicle: {
                endpoint: '/locations/:location_id/cars/:vehicle_id/history',
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreDefaultAssociationMapper: true
            },
            forContract: {
                endpoint: '/locations/:location_id/reservations/:contract_id/car_reservations',
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreDefaultAssociationMapper: true
            }
        },
        responseTransforms: {
            index: function(args, data) {
                data.forEach(function(record) {
                    record.data.length_of_loan = Math.ceil(moment(record.data.finished_at).diff(moment(record.data.started_at), 'days', true));
                    record.data.started_at_display = toLocalTime(record.data.started_at);
                    record.data.finished_at_display = toLocalTime(record.data.finished_at);
                    record.data.customer_pay_days = record.data.customer_pay_days || 0;
                });
            }
        }
    });

    function toLocalTime(timestamp) {
        return timestamp ? DataUtils.getInstance().formatTimestampSimple(timestamp, $mobilityCompanyAuthentication.location.time_zone_name) : undefined;
    }

    jQuery.extend(collection.prototype,{});

    return collection;
});
